<template>
  <v-snackbar
    class="nq-snack"
    :class="{ 'nq-snack__expanded': isExpanded }"
    v-model="isSnackBarShown"
    bottom
    right
    :timeout="snackBarShowTimeout"
    max-width="450"
  >
    <div v-if="currentNotification" @click="expandNotification">
      <v-btn
        icon
        x-small
        class="close-btn"
        @click.stop="isSnackBarShown = false"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <p class="main-title">
        {{ currentNotification.senderFullName }}
      </p>
      <p class="subtitle d-flex">{{ currentNotification.category }}</p>
      <p v-if="isExpanded" class="ml-auto date">
        {{ currentNotification.createdDate | formatDateTime }}
      </p>
      <p v-if="isExpanded" class="subtitle">
        <span class="label">{{ $t("ed") }}:</span>
        {{ currentNotification.execDocNumber }}
      </p>
      <p v-html="currentNotification.text" class="message mb-0" />
      <router-link
        v-if="isExpanded"
        :to="{
          name: 'NotificationDetail',
          params: {
            guid: currentNotification.guid,
            id: currentNotification.id,
          },
        }"
        class="mt-4 d-block"
        target="_blank"
        ><span class="text-decoration-underline">{{ $t("goTo") }}</span>
        >></router-link
      >
    </div>
  </v-snackbar>
</template>
<script lang="ts">
import { NotificationDto, NotificationPage } from "@/types/notifications";
import { translate, wait } from "@/utils";
import { Component, Vue, Watch } from "vue-property-decorator";
import notificationApi from "@/services/api/notification.api";

@Component({
  name: "NotificationsQueue",
})
export default class extends Vue {
  async created() {
    await wait(5000);
    this.getNotificationsQueue();
  }
  isNotification = true;
  isSnackBarShown = false;
  isExpanded = false;

  @Watch("isSnackBarShown")
  async handleSnackBarHide(value: boolean) {
    if (value) return;
    await wait(500);
    this.notificationsQueue?.shift();
    this.showNotification();
  }

  notificationsQueue: NotificationDto[] | null = null;
  get currentNotification() {
    return this.notificationsQueue?.length
      ? translate(this.notificationsQueue?.[0])
      : null;
  }

  async getNotificationsQueue() {
    this.notificationsQueue = await notificationApi.getNotificationsQueue();
    this.showNotification();
  }

  async showNotification() {
    if (!this.notificationsQueue?.length) {
      wait(this.updateInterval).then(this.getNotificationsQueue);
      return;
    }
    this.isExpanded = false;
    this.isSnackBarShown = true;
  }

  get snackBarShowTimeout() {
    return 7000;
  }

  get updateInterval() {
    return 600000;
  }

  expandNotification() {
    if (this.isExpanded) return;
    this.isExpanded = true;
    this.setRead();
  }
  setRead() {
    notificationApi.setRead(
      this.currentNotification!.guid!,
      this.currentNotification!.id!,
      this.isNotification,
    );
  }

  get SYSTEM_NOTIFS() {
    return NotificationPage.SYSTEM_NOTIFS;
  }
}
</script>
<style lang="scss">
.nq-snack {
  .v-snack__wrapper {
    .v-snack__content {
      font-size: 16px;
      line-height: 19px;
      color: white;
      padding-top: 10px;
      overflow: hidden;
      cursor: pointer;
    }
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      opacity: 0.54;
    }
    background: rgba(31, 31, 31, 0.72);
    border-radius: 0;
    .main-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      margin-bottom: 5px !important;
      margin-top: 10px;
    }
    .subtitle {
      font-weight: 500;

      margin-bottom: 15px !important;
    }
    .message {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .date {
      font-size: 14px;
      line-height: 16px;
      color: #e5e5e5 !important;
      margin-right: 10px;
    }
    .label {
      color: #e5e5e5 !important;
      margin-right: 5px;
    }
  }
  &__expanded {
    .message {
      text-overflow: initial !important;
      overflow: visible !important;
      white-space: normal !important;
    }
    .v-snack__content {
      cursor: default !important;
    }
  }
}
</style>
